module.exports = __webpack_public_path__ + "static/office_3-7cddcaecbdc0fe2aaf724ccb6186713d.png";